export default {"src":"/_next/static/media/transparent.b25d418f.svg","height":148,"width":282,"blurWidth":0,"blurHeight":0};